import { Component, OnInit, OnDestroy } from '@angular/core';
import { NxiNavigation, PortalNavigationService } from '@pershing/nxi-ng-common';

@Component({
    selector: 'thirdlevel-navigation-mobile',
    templateUrl: 'thirdlevel-navigation-mobile.component.html'
})
export class ThirdLevelMobileComponent implements OnInit, OnDestroy {
    parent: any;
    child: any;
    grandChild: any;
    constructor(
        private navigationService: PortalNavigationService) {
            this.navigationService.getParentPage().subscribe(
                parent => {
                    this.parent = parent;
            });
            this.navigationService.getChildPage().subscribe(
                child => {
                    this.child = child;
            });
            this.navigationService.getGrandChildPage().subscribe(
                grandChild => {
                    this.grandChild = grandChild;
            });
    }
    ngOnInit(): void {
        console.log(' In Component OnInit ');
    }

    public ngOnDestroy() {
        console.log(' In thirdlevelComponent Destroy ');
    }

    handleThirdLevelNavigation(grandchildpage): void {
        let navigation = new NxiNavigation();
        navigation.parentPage = this.parent;
        navigation.childPage = this.child;
        navigation.grandchildPage = grandchildpage;
        this.navigationService.handleNavigation(navigation);
    }

    handleBackNavigation(): void {
        let navigation = new NxiNavigation();
        navigation.parentPage = this.parent;
        navigation.childPage = this.child;
        this.navigationService.handleNavigation(navigation);
    }
}
